 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_COVER from '@/components/00_Cover'
 import A0A_HALF from '@/components/00a_Half'
 import LOVE_1 from '@/components/love_1'
 import A1_TITLE from '@/components/01_Title'
 import A2_COPY from '@/components/02_Copy'
 import A3_CONTENTS from '@/components/03_Contents'
 import A4_FOREWORD from '@/components/04_Foreword'
 import A5_INTRODUCTION from '@/components/05_Introduction'
 import A6_CHAPTER01 from '@/components/06_Chapter01'
 import A7_CHAPTER02 from '@/components/07_Chapter02'
 import A8_CHAPTER03 from '@/components/08_Chapter03'
 import A9_CHAPTER04 from '@/components/09_Chapter04'
 import A0_CHAPTER05 from '@/components/10_Chapter05'
 import A1_CHAPTER06 from '@/components/11_Chapter06'
 import A2_CHAPTER07 from '@/components/12_Chapter07'
 import LOVE_2 from '@/components/love_2'
 import A3_FORMATIONS from '@/components/13_Formations'
 import A4_REFERENCES from '@/components/14_References'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/03_Contents",
 			"name" : "03_Contents",
 			"component" : A3_CONTENTS
 		},
 		{
 			"path" : "/04_Foreword",
 			"name" : "04_Foreword",
 			"component" : A4_FOREWORD
 		},
 		{
 			"path" : "/05_Introduction",
 			"name" : "05_Introduction",
 			"component" : A5_INTRODUCTION
 		},
 		{
 			"path" : "/06_Chapter01",
 			"name" : "06_Chapter01",
 			"component" : A6_CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js